<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
  <div class="card-body">
    <dtg-analytics-drive-carbon-list></dtg-analytics-drive-carbon-list>
  </div>
</div>
